const state = {
  list: [],
  isLoading: false,
  isUploading: false,
  filter: {},
  hasEmpty: false,
  selectedUnused: [],
  walletDetails: null,
  attachments: null,
};

export default state;
